import {
  ADD_ALARM_DEVICE_DETAILS,
  ADD_ALARM_DEVICE_TYPES,
  ADD_SPECIFIC_ALARM_DEVICE_DETAILS,
} from '../actions/alarmDeviceActions';
import {
  ADD_ALERT_DEVICE_DETAILS,
  ADD_ALERT_DEVICE_TYPES,
  ADD_ALERT_GROUP_LIST,
  ADD_ALERT_DEVICE_CATEGORIES,
  ADD_ALERT_GROUP_ASSIGNMENT,
  ADD_PROCESS_DETAILS,
  REMOVE_ALERT_GROUP_ASSIGNMENT,
  ADD_PARENT_ALERT_GROUPS,
  REMOVE_ALERT_DEVICE_DETAIL,
} from '../actions/alertDeviceActions';
import {
  INSERT_DEVICE_ASSOCIATIONS,
  REMOVE_DEVICE_ASSOCIATION,
} from '../actions/deviceActions';

/**
 * Reducers for the user interface actions.
 * @param {object} state
 * @param {object} action
 */
function devices(
  state = {
    alarmDeviceDetails: {},
    alertDeviceDetails: {},
    alarmDeviceTypes: {},
    alertDeviceTypes: {},
    assignedAlertGroups: {},
    parentAlertGroups: {},
    alertDeviceCategories: {},
    deviceAssociations: {},
    processDetails: {},
    specificAlarmDevices: {},
  },
  action
) {
  switch (action.type) {
    case ADD_ALERT_DEVICE_DETAILS:
      const alertDeviceDetail = action.payload;

      return {
        ...state,
        alertDeviceDetails: {
          ...state.alertDeviceDetails,
          ...alertDeviceDetail,
        },
      };
    case REMOVE_ALERT_DEVICE_DETAIL: {
      const updated = { ...state.alertDeviceDetails };
      delete updated[action.payload];
      return { ...state, alertDeviceDetails: updated };
    }
    case ADD_ALARM_DEVICE_DETAILS:
      const alarmDeviceDetail = action.payload;

      return {
        ...state,
        alarmDeviceDetails: {
          ...state.alarmDeviceDetails,
          ...alarmDeviceDetail,
        },
      };
    case ADD_ALERT_DEVICE_TYPES:
      const addedAlertTypes = action.payload;
      return {
        ...state,
        alertDeviceTypes: {
          ...addedAlertTypes,
        },
      };
    case ADD_ALARM_DEVICE_TYPES:
      const addedAlarmTypes = action.payload;
      return {
        ...state,
        alarmDeviceTypes: {
          ...addedAlarmTypes,
        },
      };
    case ADD_PARENT_ALERT_GROUPS:
      return {
        ...state,
        parentAlertGroups: {
          ...action.payload,
        },
      };
    case ADD_ALERT_GROUP_LIST:
      const addedAlertGroups = action.payload;
      return {
        ...state,
        assignedAlertGroups: {
          ...addedAlertGroups,
        },
      };
    case ADD_ALERT_GROUP_ASSIGNMENT:
      return {
        ...state,
        assignedAlertGroups: {
          ...state.assignedAlertGroups,
          ...action.payload,
        },
      };
    case ADD_ALERT_DEVICE_CATEGORIES:
      const addedAlertCategories = action.payload;
      return {
        ...state,
        alertDeviceCategories: {
          ...addedAlertCategories,
        },
      };

    case INSERT_DEVICE_ASSOCIATIONS:
      return {
        ...state,
        deviceAssociations: {
          ...state.deviceAssociations,
          ...action.payload,
        },
      };

    case REMOVE_DEVICE_ASSOCIATION:
      let associations = { ...state.deviceAssociations };
      delete associations[action.payload];
      return {
        ...state,
        deviceAssociations: {
          ...associations,
        },
      };

    case ADD_PROCESS_DETAILS:
      return {
        ...state,
        processDetails: {
          ...state.processDetails,
          ...action.payload,
        },
      };

    case ADD_SPECIFIC_ALARM_DEVICE_DETAILS:
        return {
          ...state,
          specificAlarmDevices: {
            ...state.specificAlarmDevices,
            ...action.payload,
          },
        };

    case REMOVE_ALERT_GROUP_ASSIGNMENT:
      let alertGroups = { ...state.assignedAlertGroups };
      delete alertGroups[action.payload]; // action.payload should be the seq ID
      return {
        ...state,
        assignedAlertGroups: {
          ...alertGroups,
        },
      };
    default:
      return state;
  }
}
export default devices;
